import { useEffect, useRef, useState } from "react";
import useReducedMotion from "./useReducedMotion";

/** Animates 0 → `to` with an ease-out, but only once the element is on screen. */
export default function useCountUp(to, active, { duration = 1600, delay = 0 } = {}) {
  const [value, setValue] = useState(0);
  const reduced = useReducedMotion();
  const doneRef = useRef(false);

  useEffect(() => {
    if (!active || doneRef.current) return undefined;
    if (reduced) {
      setValue(to);
      doneRef.current = true;
      return undefined;
    }

    let raf = 0;
    let start = 0;

    const tick = (now) => {
      if (!start) start = now + delay;
      const t = Math.max(0, Math.min(1, (now - start) / duration));
      setValue(Math.round(to * (1 - Math.pow(1 - t, 3))));
      if (t < 1) raf = requestAnimationFrame(tick);
      else doneRef.current = true;
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, to, duration, delay, reduced]);

  return value;
}
